import React, { useRef, useState } from "react";
import { Card, Form, Button } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { AccountErrorMessages, ChangeAuthenticationUIActionTypes, GlobalConstants, Message, useAppDispatch } from "src/common";
import { VerificationCode, QRCode } from "src/components";
import { uiActions } from "src/store";
import { authenticator } from "otplib";

type AllProps = {
  user_id: string;
  totp_secret: string;
  handleAction: ActionHandlerFunction;
}

function TOTPFormComponent(props: AllProps) {
  const { user_id, totp_secret, handleAction } = props;
  const dispatch = useAppDispatch();
  const [reset, setReset] = useState<boolean>(false);
  const button_ref = useRef<HTMLButtonElement>(null);
  const otp_uri = authenticator.keyuri(user_id, "PreVeil", totp_secret);
  let totp_code = "";

  // Description: Validate and set secret code on finished. Auto-submit on valid code
  function handleSetSecretCode(code: string) {
    totp_code = code;
    const button = button_ref.current;
    const is_valid = code.length === GlobalConstants.CREATE_ACCOUNT_VERIFICATION_CODE_MAX;
    if (!!button) {
      button.disabled = !is_valid;
      is_valid && setTimeout(() => button.focus());
    }
    is_valid && handleSubmit();
  }

  // Description: Handle form submit
  function handleSubmit() {
    authenticator.options = { window: 1 };
    const valid_code = authenticator.check(totp_code, totp_secret);
    if (valid_code) {
      handleAction({ actionType: ChangeAuthenticationUIActionTypes.SubmitTOTPVerificationCode, params: totp_code });
    } else {
      // NOTE: Removed the handleRequestErrors because it was causing the incorrect reload of the component
      // Directly reset the Verification control on error
      setReset(true);
      dispatch(uiActions.handleRequestErrors(new Message(AccountErrorMessages.bad_totp_code)));
    }
  }

  // Description: Render the enter code
  function VerificationForm() {
    return <>
      <h3 className="border-bottom">Switch to an Authenticator Application</h3>
      <p>Scan the Quick Response (QR) code below with an authenticator application.</p>
      <Form onSubmit={(e) => {
        e.stopPropagation();
        e.preventDefault();
        handleSubmit();
      }} noValidate>
        <Form.Group className="mb-3" >
          <div className="totp-code">
            <QRCode code={otp_uri} width={150} />
          </div>
          <Form.Label>Enter the generated TOTP (Time based one time password) code below and submit it to PreVeil.</Form.Label>
          <VerificationCode
            count={GlobalConstants.CREATE_ACCOUNT_VERIFICATION_CODE_MAX}
            reset={reset}
            setReset={setReset}
            handleAction={handleSetSecretCode} />
          <Form.Text>
            <details>
              <summary>Unable to scan the QR code?</summary>
              <p>
                If you are unable to scan the code in your authenticator application then enter the following
                secret in the application to get your TOTP code. Then submit the code to PreVeil in the step above
              </p>
              <p className="mb-5"><b>{totp_secret}</b></p>
            </details>
          </Form.Text>
        </Form.Group>
        <div className="btn-panel">
          <Button type="submit" ref={button_ref} disabled={true} >Verify</Button>
          <Button variant="outline-secondary" type="button" onClick={() => handleAction({ actionType: ChangeAuthenticationUIActionTypes.ResetForms })}>Cancel</Button>
        </div>
      </Form>
    </>;
  }

  return <>
    <Card.Body>
      <VerificationForm />
    </Card.Body>
  </>;
}
export default React.memo(TOTPFormComponent);
